export const environment = {
  production: true,
  staging: false,
  name: "prod",
  sentry_dsn: "https://8cf46ae2e3224f3689cf0f8e5fdddbea@o4504765790420992.ingest.sentry.io/4504766511251456",
  api: {
    url: "https://api-nexu.herokuapp.com",
    maps_key: "AIzaSyARgV5VYq-SWfd2tdWcGWJdcm5lt8VM8mU",
  },
  ordas_api: {
    url: "https://ordas.nexu.mx",
  },
  inter_api: {
    url: "https://inter.nexu.mx",
  },
  analytics: {
    gtag_id: "G-DP2R91XNZM",
    enabled: true,
  },
};
